import React from "react";
import { Hexagon } from "lucide-react";

/**
 * Logo component with fallback.
 * When a logo image URL is available, it renders an <img>.
 * When no URL is provided, it renders the Lucide Hexagon icon
 * with a neon glow effect as a premium fallback.
 */
export function LogoMark({ src, size = "w-9 h-9", className = "", alt = "Nordgaming" }) {
  if (src) {
    return <img src={src} alt={alt} className={`${size} logo-glow ${className}`} />;
  }
  // Fallback: Hexagon icon with neon styling
  const sizeNum = parseInt(size.match(/w-(\d+)/)?.[1] || "9", 10);
  const iconPx = Math.max(12, sizeNum * 2.5);
  return (
    <div className={`${size} flex items-center justify-center ${className}`}>
      <Hexagon
        className="text-primary logo-glow"
        style={{ width: iconPx, height: iconPx }}
        strokeWidth={1.5}
        fill="rgba(0, 240, 255, 0.08)"
      />
    </div>
  );
}

export function LogoFull({ src, size = "w-full max-w-md", className = "", alt = "Nordgaming - Play beyond limits" }) {
  if (src) {
    return <img src={src} alt={alt} className={`${size} logo-glow animate-float ${className}`} />;
  }
  // Fallback: Large hexagon with "NG" text overlay
  return (
    <div className={`${size} flex items-center justify-center ${className}`}>
      <div className="relative animate-float">
        <Hexagon
          className="text-primary logo-glow"
          style={{ width: 200, height: 200 }}
          strokeWidth={0.8}
          fill="rgba(0, 240, 255, 0.05)"
        />
        <span
          className="absolute inset-0 flex items-center justify-center font-display text-6xl font-black tracking-tighter text-gradient"
          style={{ textShadow: "0 0 40px rgba(41, 233, 255, 0.3)" }}
        >
          NG
        </span>
      </div>
    </div>
  );
}
